import React, { useState, useMemo, useEffect, useRef } from 'react'
import GoogleMap from 'app/maps/GoogleMap'
import StaticGoogleMap from 'app/maps/StaticGoogleMap'
import { Marker } from '@react-google-maps/api'
import styles from './OfficeMap.module.css'
import mapIcon from 'assets/svg/map-icon.svg'

export default function OfficeMap() {
  const mapRef = useRef()
  const [loaded, setLoaded] = useState(false)
  const [bounds, setBounds] = useState()

  return (
    <section
      className="bg-white py-16"
      aria-labelledby="office-location-heading"
    >
      <div className="container max-w-5xl">
        <h1
          id="office-location-heading"
          className="text-4xl font-platform text-center text-black font-bold leading-tight flex items-center justify-center"
        >
          <img
            src={mapIcon}
            className="block mr-3"
            width="24"
            height="24"
            alt="Map Marker"
            aria-hidden="true"
          />
          Roaming Hunger Corporate Address
        </h1>
        <p className="text-xl text-blue text-center mt-4">
          <a
            href="https://www.google.com/maps/search/?api=1&query=10951+West+Pico+Boulevard+Los+Angeles+CA+90064"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
            aria-label="Open 10951 West Pico Boulevard in Google Maps"
          >
            10951 West Pico Boulevard Los Angeles, CA 90064
          </a>
        </p>
        <div
          className={styles.container}
          role="region"
          aria-label="Interactive map showing Roaming Hunger office location"
        >
          {loaded ? (
            <GoogleMap
              className="w-full"
              zoom={16}
              useMarker={true}
              center={{
                lng: -118.4311522,
                lat: 34.038921,
              }}
              aria-label="Interactive map of Roaming Hunger office location"
            >
              <Marker
                color="20B5FF"
                position={{
                  lng: -118.4311522,
                  lat: 34.038921,
                }}
                title="Roaming Hunger Office"
              />
            </GoogleMap>
          ) : (
            <button
              onClick={() => {
                setLoaded(true)
              }}
              className={[
                'absolute inset-0 bg-gray-300 w-full h-full',
                'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
              ].join(' ')}
              aria-label="Load interactive map"
            >
              <StaticGoogleMap
                center={{
                  lng: -118.4311522,
                  lat: 34.038921,
                }}
                lat={34.038921}
                lng={-118.4311522}
                markerColor="20B5FF"
                className={[
                  'absolute inset-0 w-full h-full shadow-inner',
                  styles.map,
                ]}
                zoom={15}
                alt="Static map showing Roaming Hunger office location"
              />
            </button>
          )}
        </div>
      </div>
    </section>
  )
}
